import { gate } from 'hub-http/gates';
export const GATES = {
  GO_TO_MARKETING_STUDIO: gate('GoToMarketingStudio'),
  CHANGES_REQUESTED: gate('ProductApprovals:ChangesRequested'),
  V2_APPROVAL_EDITOR_BUTTONS: gate('ProductApprovals::EditorApprovalButtons'),
  AGENT_APPROVER: gate('ProductApprovals::AgentApprover'),
  PAGE_EDITOR_AI_EDITING_EXPERIMENT: gate('PageEditorAIEditingExperiment'),
  EDITOR_V2_APPROVALS: gate('EdExt::EditorV2::Approvals'),
  AGENT_IMPLEMENTING_REQUESTED_CHANGES: gate('ProductApprovals::AgentImplementingRequestedChanges'),
  // Controls reading the new generic (V2) unified events in the sidepanel
  // instead of the legacy per-type (V1) events.
  UE_GENERIC: gate('ProductApprovals::UE::Generic'),
  ORDERED_APPROVAL_STEPS: gate('ProductApprovals::OrderedApprovalSteps')
};